import * as React from 'react';

export default function Parking({ className, viewBox }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      viewBox={viewBox || '0 0 16 16'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6562 0H2.34375C1.05147 0 0 1.05147 0 2.34375V13.6562C0 14.9485 1.05147 16 2.34375 16H13.6562C14.9485 16 16 14.9485 16 13.6562V2.34375C16 1.05147 14.9485 0 13.6562 0ZM8.96875 8.96875H7.03125V12.25C7.03125 12.5089 6.82138 12.7188 6.5625 12.7188H5.625C5.36612 12.7188 5.15625 12.5089 5.15625 12.25V8.96875V4.28125V3.8125C5.15625 3.55362 5.36612 3.34375 5.625 3.34375H8.96875C10.5197 3.34375 11.7812 4.60534 11.7812 6.15625C11.7812 7.70716 10.5197 8.96875 8.96875 8.96875Z"
        fill="currentColor"
      />
    </svg>
  );
}
